import {observer} from "mobx-react";
import {ReactNode} from "react";
import './data-card-grid-layout.scss';
interface IDataCardGridLayoutProps {
    children: ReactNode;
}
const DataCardGridLayout : React.FC<IDataCardGridLayoutProps> = observer(({children})=> {
    return (
        <div className={'data-card-grid-layout'}>
            {children}
        </div>
    )
});

export default DataCardGridLayout;